const paragraph = require('./paragraph');
const link = require('./link');
const head = require('./head');
const list = require('./list');
const raw = require('./raw');
const quote = require('./quote');
const checklist = require('./checklist');
const embed = require('./embed');
const image = require('./image');
const table = require('./table');
const code = require('./code');
const warning = require('./warning');
const delimiter = require('./delimiter');
const attaches = require('./attaches');
const gallery = require('./gallery');
const carousel = require('./carousel');

module.exports = {
    paragraph,
    link,
    head,
    list,
    raw,
    quote,
    checklist,
    embed,
    image,
    table,
    code,
    warning,
    delimiter,
    attaches,
    gallery,
    carousel,
};
